import * as React from 'react';
import { Grid, Divider } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationRoom, reservationSlot } from '../../../../model/reservation';
import ReservationDay from './ReservationDay';
import ReservationHours from './ReservationHours';
import moment from 'moment';
import { getMinutesOfDay, getReservationMaxEndtDate, getReservationMinStartDate } from './commonReservation-utilities';
import ReservationCalendarHeader from './ReservationCalendarHeader';
import { SelectItem } from '../../../../ui-components/select/Select';

interface IProps extends StyledComponentProps {
    disabled: boolean;
    reservationRooms: reservationRoom[];
    loadReservationRoom: (viewType: "day" | "week", date?: Date) => void;
    roomSelected: SelectItem;
    dayView: Date;
    filterDate: Date;
    setFilterDate: (day: Date) => void;
    viewType: "day" | "week";
    updateViewType: (viewType: "day" | "week") => void;
    classes: any;
    smallScreen: boolean;
    showReservationSlotDetail: (reservationSlot: reservationSlot, reservationRoom: reservationRoom) => void;
}

const minuteHeight = 1.7;




class ReservationCalendar extends React.Component<IProps> {

    getMinStartDate = (reservationRooms: reservationRoom[]) => {
        let minDate: moment.Moment = undefined;
        reservationRooms.forEach(reservationRoom => {
            let minDateReservation = getReservationMinStartDate(reservationRoom);
            if (minDateReservation) {
                minDate = minDate === undefined ? minDateReservation : getMinutesOfDay(minDate) <= getMinutesOfDay(minDateReservation) ? minDate : minDateReservation;
            }
        })
        return minDate ? minDate.toDate() : moment().set({ hour: 8, minute: 0 }).toDate();
    }


    getMaxEndDate = (reservationRooms: reservationRoom[]) => {
        let maxDate: moment.Moment = undefined;
        reservationRooms.forEach(reservationRoom => {
            let maxDateReservation = getReservationMaxEndtDate(reservationRoom);
            if (maxDateReservation) {
                maxDate = maxDate === undefined ? maxDateReservation : getMinutesOfDay(maxDate) >= getMinutesOfDay(maxDateReservation) ? maxDate : maxDateReservation;
            }
        })
        return maxDate ? maxDate.toDate() : moment().set({ hour: 19, minute: 0 }).toDate();
    }

    nextDayWeek = () => {
        this.props.setFilterDate(moment(this.props.dayView).add(1, this.props.viewType).toDate());
        this.props.loadReservationRoom(this.props.viewType, moment(this.props.dayView).add(1, this.props.viewType).toDate())
    }

    prevDayWeek = () => {
        this.props.setFilterDate(moment(this.props.dayView).subtract(1, this.props.viewType).toDate());
        this.props.loadReservationRoom(this.props.viewType, moment(this.props.dayView).subtract(1, this.props.viewType).toDate())
    }

    render() {
        const classes = this.props.classes;
        let minStartTime = this.getMinStartDate(this.props.reservationRooms);
        let maxEndTime = this.getMaxEndDate(this.props.reservationRooms);
        let disabledChangeDay = this.props.roomSelected === undefined || this.props.disabled;
        return (<Grid container className={classes.reservationCalendarContainer}>
            <ReservationCalendarHeader
                disabled={this.props.disabled}
                classes={classes}
                disabledChangeDay={disabledChangeDay}
                dayView={this.props.dayView}
                roomSelected={this.props.roomSelected}
                setFilterDate={this.props.setFilterDate}
                nextDayWeek={this.nextDayWeek}
                prevDayWeek={this.prevDayWeek}
                smallScreen={this.props.smallScreen}
                updateViewType={this.props.updateViewType}
                viewType={this.props.viewType}
                filterDate={this.props.filterDate} />
            <Divider style={{ width: "100%", marginTop: "10px" }} />
            <Grid container className={classes.reservationCalendarBodyContainer} >
                <ReservationHours
                    classes={classes}
                    maxEndTime={maxEndTime}
                    minStartTime={minStartTime}
                    minuteHeight={minuteHeight} />
                {this.props.reservationRooms.map(res =>
                    <ReservationDay
                        classes={classes}
                        disabledChangeDay={disabledChangeDay}
                        nextDay={this.nextDayWeek}
                        prevDay={this.prevDayWeek}
                        viewType={this.props.viewType}
                        disabled={this.props.disabled}
                        showReservationSlotDetail={this.props.showReservationSlotDetail}
                        reservationRoom={res}
                        maxEndTime={maxEndTime}
                        minStartTime={minStartTime}
                        minuteHeight={minuteHeight} />)}
            </Grid>
        </Grid>);
    }

};
export default withStyles(styles as any)(ReservationCalendar)